import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['PopupGalleryStyles-cvaRoot', 'fixed left-0 top-0 z-[99]', 'w-full h-full', 'bg-cWhite']);

export const cvaClose = cva([
  'PopupGalleryStyles-cvaClose',
  ' z-[10]',
  'flex items-center justify-center',
  'w-4 sm:w-5.6 h-4 sm:h-5.6',
  'bg-cMediumGreyOnWhite',
  'rounded-[1.2rem] sm:rounded-[1.6rem]',
  'border-none outline-none',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon = cva(['PopupGalleryStyles-cvaCloseIcon', 'w-1.6 h-1.6', 'fill-cBlack']);

export const cvaSlideWrapper = cva([
  'PopupGalleryStyles-cvaSlideWrapper',
  'h-full',
  'select-none',
  'flex items-center justify-center',
]);

export const cvaSlideButtonWrapper = cva(
  ['PopupGalleryStyles-cvaSlideButtonWrapper', 'absolute top-1/2 -translate-y-1/2 z-[10]'],
  {
    variants: {
      direction: {
        prev: ['left-2.4'],
        next: ['right-2.4'],
      },
    },
    defaultVariants: {
      direction: 'prev',
    },
  }
);

export const cvaSlideButton = cva([
  'PopupGalleryStyles-cvaSlideButton',
  'hidden sm:flex items-center justify-center',
  'w-5.6 h-5.6',
  'bg-cMediumGreyOnWhite',
  'rounded-[1.6rem]',
  'border-none outline-none',
  'cursor-pointer select-none',
]);

export const cvaSlideButtonIcon = cva(['PopupGalleryStyles-cvaSlideButtonIcon', 'w-1.6 h-1.6', 'stroke-cBlack'], {
  variants: {
    direction: {
      prev: ['rotate-180'],
      next: [''],
    },
  },
  defaultVariants: {
    direction: 'prev',
  },
});

export const cvaPagination = cva([
  'PopupGalleryStyles-cvaPagination',
  'absolute bottom-2.4 z-[10] left-0',
  'flex items-center justify-center gap-0.8',
  'w-full h-0.6',
  'sm:hidden',
  'text-0',
  '[&>.swiper-pagination-bullet]:opacity-100 [&>.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)]:bg-cBlack32 [&>.swiper-pagination-bullet-active]:bg-cBlack',
]);

export const cvaSlider = cva(
  ['PopupGalleryStyles-cvaSlider', 'z-[0]', 'w-full h-full', 'transition-all duration-300'],
  {
    variants: {
      showVideo: {
        true: ['visibility-hidden opacity-0'],
        false: [''],
      },
    },
  }
);

export const cvaSlide = cva(['PopupGalleryStyles-cvaSlide', 'flex justify-center items-center', 'w-1/2 h-full']);

export const cvaSlideImage = cva(
  [
    'PopupGalleryStyles-cvaSlideImage',
    'flex items-center justify-center',
    // '[&>div]:flex [&>div]:justify-center [&>div]:items-center [&>div]:h-fit [&>div]:w-fit [&>div]:absolute [&>div]:left-1/2 [&>div]:top-1/2 [&>div]:-translate-x-1/2 [&>div]:-translate-y-1/2',
    'relative',
    'w-fit h-fit',
    '[height:revert-layer]',
    // 'origin-center',
    // '[&>div]:absolute [&>div]:left-2.4 sm:[&>div]:left-4.9 [&>div]:top-2.4 sm:[&>div]:top-4.9 [&>div]:right-5 sm:[&>div]:right-5 [&>div]:bottom-2.4 sm:[&>div]:bottom-4.9 [&>div>img]:w-full [&>div>img]:h-full [&>div>img]:object-center [&>div>img]:object-contain',
  ],
  {
    variants: {
      cursor: {
        plus: [''],
        // minus: ['scale-150'],
      },
    },
    defaultVariants: {
      cursor: 'plus',
    },
  }
);

export const cvaThumbsContainer = cva([
  'PopupGalleryStyles-cvaThumbsContainer',
  'absolute top-4 left-2.4 bottom-4 z-[8]',
  'h-fit',
  'hidden sm:block',
]);

export const cvaThumbs = cva(['PopupGalleryStyles-cvaThumbs', 'h-full']);

export const cvaThumbsSlide = cva([
  'PopupGalleryStyles-cvaThumbsSlide',
  'relative',
  'flex items-center justify-center',
  'w-7.2 h-7.2',
  'cursor-pointer select-none',
  'transition-colors duration-300',
  'border-[1px] border-transparent rounded-[1.6rem] [&.swiper-slide-thumb-active]:border-cMediumGreen',
]);

export const cvaThumbsSlideImage = cva([
  'PopupGalleryStyles-cvaThumbsSlideImage',
  'w-5.6 h-5.6',
  'object-center object-contain',
]);

export const cvaVideoThumbWrapper = cva([
  'PopupGalleryStyles-cvaVideoThumb',
  'h-auto mt-auto',
  // 'absolute bottom-4 left-2.4 z-[9]',
]);

export const cvaVideoThumbTitle = cva(['PopupGalleryStyles-cvaVideoThumbTitle', 'text-bodyXS text-cBlack48']);

export const cvaVideoThumb = cva([
  'PopupGalleryStyles-cvaVideoThumb',
  'relative overflow-hidden',
  'flex items-center justify-center',
  'w-7.2 h-7.2',
  'mb-0.8',
  'bg-cLightGreen',
  'rounded-[1.6rem]',
  'before:z-[1] before:absolute before:w-full before:h-full before:left-0 before:top-0 before:bg-cBlack08',
  'cursor-pointer select-none',
]);

export const cvaVideoThumbIcon = cva([
  'PopupGalleryStyles-cvaVideoThumbIcon',
  'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[2]',
  'w-2.4 h-2.4',
  'fill-cWhite',
]);

export const cvaVideoThumbImage = cva([
  'PopupGalleryStyles-cvaVideoThumbImage',
  'w-5.6 h-5.6',
  'object-contain object-center',
]);

export const cvaVideoWrapper = cva([
  'PopupGalleryStyles-cvaVideoWrapper',
  'relative',
  // 'absolute left-0 top-0 z-[7]',
  'flex items-center justify-between',
  'w-full h-full',
  'py-2.4 sm:py-9 px-2.4 sm:px-[14.1rem]',
]);

export const cvaVideo = cva(['PopupGalleryStyles-cvaVideo', 'w-full', 'aspect-[16/9]']);

export const cvaVideoIframe = cva(['PopupGalleryStyles-cvaVideoIframe', 'w-full h-full']);
